import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
  withCredentials: true, // send session_token cookie on every request
});

export async function generateReport(payload) {
  const { data } = await api.post("/reports/generate", payload);
  return data;
}

export async function getReport(reportId) {
  const { data } = await api.get(`/reports/${reportId}`);
  return data;
}

export async function devUnlock(reportId) {
  const { data } = await api.post(`/reports/${reportId}/dev-unlock`);
  return data;
}

export async function startCheckout({ reportId, plan, email }) {
  const { data } = await api.post("/checkout/session", {
    report_id: reportId,
    plan,
    email,
    origin_url: window.location.origin,
  });
  return data; // { checkout_url, session_id }
}

export async function verifyCheckout(sessionId) {
  const { data } = await api.get(`/checkout/verify/${sessionId}`);
  return data; // { paid, report_id }
}

export function printReportUrl(reportId) {
  return `${API_BASE}/reports/${reportId}/print`;
}

export const SAMPLE_IDS = [
  "sample-fatigue",
  "sample-thyroid",
  "sample-joints",
  "sample-headache-imaging",
];
